<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        :to="{name: 'paciente',params: { id: data.item.idPaciente }}" >
      <p
          v-if="resource.idEstatusSolicitud === 1"
          class="letraColorAzulPrincipal letraEstiloNegrita"
          @click="putCambiarEstatusSolicitud(data.item)"

      >

        {{ data.item.nombrePaciente }}
      </p>

      <p class="letraColorAzulPrincipal letraEstiloNegrita" v-else>{{ data.item.nombrePaciente }}</p>
    </router-link>
  </div>

</template>

<script>
import {MotorService} from "@/apiServices/motor/MotorService";

export default {
    name: "LinkPacientePerfilBandejaEspecialidadComponente",
    props: {
        data: Object,
        resource: Object
    },
  data() {
    return {
      motorServicio : new MotorService(),
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
        putCambiarEstatusSolicitud(item) {
                var params = {
                    idSolicitudBandejaEspecialista: item.idSolicitudBandejaEspecialista,
                    idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
                }; 
                this.$http
                    .put(this.$api + "bandejaespecialista/cambiarestatussolicitud", params)
                    .then((response) => {
                      this.siguenteFlujo(item.idSolicitudEtapa);
                        return response;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

      siguenteFlujo(idSolicitudEtapa) {

        const params = {
        idSolicitudEtapa: idSolicitudEtapa,
        objeto: null
      }

        this.motorServicio
            .obtenerSiguenteFlujo(params)
            .then(() => {
            })
            .finally(() => {
              this.loader = false;
            });
      }
    }
}
</script>
